module.exports = __webpack_public_path__ + "img/suitcase.38dad7f3.svg";